__turbopack_context__.v({
  "item": "loadingStyles-module-scss-module__7cBgdq__item",
  "leftCol": "loadingStyles-module-scss-module__7cBgdq__leftCol",
  "price": "loadingStyles-module-scss-module__7cBgdq__price",
  "rating": "loadingStyles-module-scss-module__7cBgdq__rating",
  "rightCol": "loadingStyles-module-scss-module__7cBgdq__rightCol",
  "sort": "loadingStyles-module-scss-module__7cBgdq__sort",
  "square": "loadingStyles-module-scss-module__7cBgdq__square",
  "swatches": "loadingStyles-module-scss-module__7cBgdq__swatches",
  "title": "loadingStyles-module-scss-module__7cBgdq__title",
  "topBar": "loadingStyles-module-scss-module__7cBgdq__topBar",
  "total": "loadingStyles-module-scss-module__7cBgdq__total",
  "wrapper": "loadingStyles-module-scss-module__7cBgdq__wrapper",
});
